import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  AlertController,
  LoadingController,
  NavController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.page.html',
  styleUrls: ['./payment-methods.page.scss'],
})
export class PaymentMethodsPage implements OnInit {
  @Input() prop: number = 0;
  paymentForm: FormGroup;
  paymentMethods=[]
  switchToAdd = false;
  isSubmitted = false;
  constructor(
    public navCtrl: NavController,

    public formBuilder: FormBuilder,
    private alertController: AlertController,
    public globals: GlobalVariable,
    private loadingController: LoadingController
  ) {
    this.paymentForm = formBuilder.group({
      creditcardno: [
        '',
        Validators.compose([
          Validators.minLength(15),
          Validators.pattern(
            '(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))'
          ),
          Validators.required,
        ]),
      ],
      CVC: [
        '',
        Validators.compose([
          Validators.minLength(3),
          Validators.pattern('[0-9]*'),
          Validators.required,
        ]),
      ],
      // name: ['', Validators.compose([Validators.minLength(2), Validators.required])],
      expiryMonth: [
        '',
        Validators.compose([Validators.minLength(1), Validators.required]),
      ],
      expiryYear: [
        '',
        Validators.compose([Validators.minLength(4), Validators.required]),
      ],
    });
  }

  ngOnInit() {}
  ionViewDidLoad() {
    console.log('ionViewDidLoad PaymentMethodsPage');
    let tempArray = [];
    let response = localStorage.getItem('paymentmethods');
    tempArray = JSON.parse(response);
    console.log('from local storage', tempArray);
    if (tempArray != null) {
      this.paymentMethods = tempArray;
    }
  }
  // dismiss() {
  //   this.viewCtrl.dismiss();
  // }
  addNewMethod() {
    this.switchToAdd = true;
    this.checkType();
  }
  selectMethod(pay) {
    this.globals.activeCreditCard = pay;
    console.log('credit card saved', this.globals.activeCreditCard);
    // this.viewCtrl.dismiss();
  }
  checkType() {
    console.log('works check', this.paymentForm.value.creditcardno);
    if (this.paymentForm.value.creditcardno[0] == '4') {
      console.log('visa');
    }
    if (this.paymentForm.value.creditcardno[0] == '5') {
      console.log('mastercard');
    }
  }
  async submit() {
    this.isSubmitted = true;
    if (!this.paymentForm.valid) {
      console.log('Please provide all the required values!');
      return false;
    }
    const loading = await this.loadingController.create({
      message: 'Adding..',
      duration: 1000,
    });
    loading.present();
    // add loading
    console.log(this.paymentForm.value);
    this.paymentMethods.push(this.paymentForm.value);
    console.log('saved methodss', this.paymentMethods);
    localStorage.setItem('paymentmethods', JSON.stringify(this.paymentMethods));
    this.switchToAdd = false;
    loading.dismiss();
    // this.paymentForm.reset();
  }
  async deletePayment(payment, index) {
    const alert = await this.alertController.create({
      message: 'You are about to delete Credit card',
      buttons: [
        {
          text: 'Cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Delete',
          handler: (data) => {
            if (index > -1) {
              this.paymentMethods.splice(index, 1);
              console.log(this.paymentMethods.length);
              localStorage.setItem(
                'paymentmethods',
                JSON.stringify(this.paymentMethods)
              );
            }
          },
        },
      ],
    });
    await alert.present();

    // this.myAddresses.splice(i,1)
    console.log('deleted', payment.creditcardno, ' from ', index, ' index');
  }
  get errorControl() {
    return this.paymentForm.controls;
  }
  cancel() {
    this.switchToAdd = false;
    // this.paymentForm.reset();
  }
}
